import React from 'react';
import FormComponent from '../utils/FormComponent';
import ModalDialog from '../utils/ModalDialog';
import i18next from 'i18next';
import * as blockUtils from '../../utils/BlockUtils';
import Form from '../utils/Form';
import ErrorBox from '../utils/ErrorBox';
import TextInput from '../utils/TextInput';
import PropTypes from 'prop-types';
import * as usersApi from '../../api/users-api';
import PasswordChecklist from 'react-password-checklist';

class EditPasswordForm extends FormComponent {
  constructor(props) {
    super(props);

    this.validatePassword = this.validatePassword.bind(this);
    this.validatePasswordConfirm = this.validatePasswordConfirm.bind(this);
    this.validatePasswordsAreDifferent = this.validatePasswordsAreDifferent.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.formatErrorMessages = this.formatErrorMessages.bind(this);
  }

  initialState() {
    return {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
      newAndOldPwAreTheSame: '',
      error: null,
    };
  }

  sendForm() {
    if (this.validatePassword() && this.validatePasswordConfirm() && this.validatePasswordsAreDifferent()) {
      if (this.props.user) {
        this.handleError('');
        const data = {
          oldPassword: this.state.oldPassword,
          newPassword: this.state.newPassword,
          newPasswordConfirmation: this.state.newPasswordConfirmation,
        };
        blockUtils.blockUI();
        usersApi.updateUserPassword(this.props.user, data).then((response) => {
          blockUtils.unblockUI();
          if (response.status !== 200) {
            window.showAlert(i18next.t('error'), response.statusText);
            return;
          }

          window.showAlert(i18next.t('success'), i18next.t('users.successful_pwd_update'));
          $(`#${this.props.dialogId}`).modal('hide');
        }).catch((err) => {
          blockUtils.unblockUI();
          let validationMessage = err.response.data.errorMessage;

          if (!validationMessage) {
            validationMessage = err.response.data.details['newPassword'];
            if (!validationMessage) {
              validationMessage = err.response.data.details['newPasswordConfirmation'];
            }
          }

          this.handleError(validationMessage ? validationMessage : err.response.data.message);
        });
      }
    }
  }

  validatePasswordsAreDifferent() {
    this.setState({
      newAndOldPwAreTheSame: null,
    });

    if (!this.state.oldPassword) {
      this.setState({
        newAndOldPwAreTheSame: i18next.t('errors.is_required', {field: i18next.t('users.attrs.old_password')}),
      });
      return false;
    }

    if (this.state.oldPassword && this.state.newPassword) {
      const passwordAreDifferent = this.state.oldPassword !== this.state.newPassword;

      if (!passwordAreDifferent) {
        this.setState({
          newAndOldPwAreTheSame: i18next.t('users.new_and_old_pw_are_the_same'),
        });
      }

      return passwordAreDifferent;
    }

    return true;
  }

  validatePassword(password = this.state.newPassword) {
    if (password) {
      this.setState({passwordError: ''});
      this.validatePasswordConfirm(this.state.passwordConfirmation);
      return true;
    } else {
      this.setState({passwordError: i18next.t('errors.is_required', {field: i18next.t('users.attrs.new_password')})});
      return false;
    }
  }

  validatePasswordConfirm(passwordConfirm = this.state.newPasswordConfirmation) {
    if (!this.state.newPassword) {
      return true;
    }
    if (this.state.newPassword === passwordConfirm) {
      this.setState({passwordConfError: ''});
      return true;
    } else {
      this.setState({passwordConfError: i18next.t('errors.not_match', {field: i18next.t('users.attrs.new_password_conf')})});
      return false;
    }
  }

  formatErrorMessages(errorMessage) {
    if (!errorMessage) {
      return '';
    }

    if (!errorMessage.includes(',')) {
      return errorMessage;
    }

    const errorMessages = errorMessage.split(',') || [];
    return (
      <ul>
        {errorMessages.map((message, index) => {
          return (
            <li key={index}>{message}</li>
          );
        })}
      </ul>
    );
  }

  render() {
    return (
      <ModalDialog
        modalTitle={i18next.t('users.edit_password')}
        dialogId={this.props.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        onSubmit={this.sendForm}
      >

        <Form>
          <ErrorBox errorMessage={this.formatErrorMessages(this.state.error)} />

          <TextInput
            fieldId="oldPassword"
            labelText={i18next.t('users.attrs.old_password')}
            isRequired={true}
            error={this.state.newAndOldPwAreTheSame}
            onChange={this.onChange}
            validate={this.validatePasswordsAreDifferent}
            value={this.state.oldPassword}
            isSecret={true}
          />

          <TextInput
            fieldId="newPassword"
            labelText={i18next.t('users.attrs.new_password')}
            isRequired={true}
            error={this.state.passwordError}
            validate={this.validatePassword}
            onChange={this.onChange}
            value={this.state.newPassword}
            isSecret={true}
          />

          <TextInput
            fieldId="newPasswordConfirmation"
            labelText={i18next.t('users.attrs.new_password_conf')}
            isRequired={true}
            error={this.state.passwordConfError}
            validate={this.validatePasswordConfirm}
            onChange={this.onChange}
            value={this.state.newPasswordConfirmation}
            isSecret={true}
          />

          <PasswordChecklist
            rules={['minLength', 'maxLength', 'specialChar', 'number', 'capital', 'match']}
            minLength={8}
            maxLength={30}
            value={this.state.newPassword}
            valueAgain={this.state.newPasswordConfirmation}
            onChange={(isValid) => {}}
          />
        </Form>
      </ModalDialog>
    );
  }
}

EditPasswordForm.propTypes = {
  user: PropTypes.object,
};

export default EditPasswordForm;
